import { Button as ButtonMU } from '@mui/material';

import styles from "./Button.module.scss";

type Props = {
  disabled?: boolean;
  text: string;
  color?: 'primary' | 'error' | 'info'| 'inherit'| 'secondary'| 'success'| 'warning';
  size?: 'large' | 'medium' |'small';
  type?: 'button' | 'submit' | 'reset';
  variant?: 'contained' | 'outlined' | 'text'
  className?: string;
  fullWidth?: boolean;
  onClick?: () => void;
  width?: number | string;
  height?: number | string;
}

const Button = ({ height, width, fullWidth=true, disabled, text, color, size='large', type='button', className, onClick, variant='contained' }: Props) => {

  const classesButton = [className];

  if (color) {
    classesButton.push(styles.button)
  } else {
    classesButton.push(styles.buttonCustomColor)
  }

  if (size === 'small') {
    classesButton.push(styles.smalSize)
  }

  if (disabled) {
    classesButton.push(styles.disabled)
  }
  
  return (
    <ButtonMU
      className={classesButton.join(' ')}
      color={color}
      disabled={disabled}
      fullWidth={fullWidth}
      size={size}
      type={type}
      onClick={onClick}
      variant={variant}
      sx={{width, height}}
    >
      {text}
    </ButtonMU>
  );
};

export { Button };
